module.exports = __webpack_public_path__ + "static/heidi2-e0f025c55bab9d29266c3e47541e5836.jpg";